import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import FacilityBankAnalysisSliceService from "services/Setup/LoanOrigination/FacilityBankAnalysis/FacilityBankAnalysisService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  loadingBankAanalis: false,
  loadingFinAalysis: false,
  loadingFacilityCapital: false,
  message: "",
  showMessage: false,
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  statusRespon: 0,
  facilityBankAnalysisList: [],
  facilityItem: [],
  guarantorItem: [],
  collateralItem: [],
  deviasiItem: [],
  creditScoringFacItem: [],
  calculateCreditScoringFacList: [],
  getCount: 0,
  redirect: "",
  creditStepFacility: null,
};

export const getFacilityBankAnalysisSlice = createAsyncThunk(
  "FacilityBankAnalysisSlice/getFacilityBankAnalysisSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await FacilityBankAnalysisSliceService.getFacilityBankAnalysisService(
          userInput
        );

      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error?.response?.status || "Error",
        description: error?.response?.statusText || "Unexpected error occurred",
        duration: 3,
      });
      return rejectWithValue(
        error?.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const addFacilityBankAnalysisSlice = createAsyncThunk(
  "FacilityBankAnalysisSlice/addFacilityBankAnalysisSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await FacilityBankAnalysisSliceService.addFacilityBankAnalysisService(
          userInput
        );

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const addFacilityFinAnalysisSlice = createAsyncThunk(
  "FacilityBankAnalysisSlice/addFacilityFinAnalysisSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await FacilityBankAnalysisSliceService.addFacilityFinAnalysisService(
          userInput
        );

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const addFacilityCapitalAnalysisSlice = createAsyncThunk(
  "FacilityBankAnalysisSlice/addFacilityCapitalAnalysisSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await FacilityBankAnalysisSliceService.addFacilityCapitalAnalysisService(
          userInput
        );

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getCreditScoringFacItemSlice = createAsyncThunk(
  "FacilityBankAnalysisSlice/getCreditScoringFacItemSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await FacilityBankAnalysisSliceService.getCreditScoringFacItemService(
          userInput
        );

      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error?.response?.status || "Error",
        description: error?.response?.statusText || "Unexpected error occurred",
        duration: 3,
      });
      return rejectWithValue(
        error?.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const posCreditScoringFacItemSlice = createAsyncThunk(
  "FacilityBankAnalysisSlice/posCreditScoringFacItemSlice",
  async (userInput, { rejectWithValue }) => {
    console.log("posCreditScoringFacItemSlice", userInput);

    try {
      const response =
        await FacilityBankAnalysisSliceService.posCreditScoringFacItemService(
          userInput
        );

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const posCreditScoringFacSaveSlice = createAsyncThunk(
  "FacilityBankAnalysisSlice/posCreditScoringFacSaveSlice",
  async (userInput, { rejectWithValue }) => {
    console.log("posCreditScoringFacSaveSlice", userInput);

    try {
      const response =
        await FacilityBankAnalysisSliceService.posCreditScoringFacSaveService(
          userInput
        );

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getSearchStepSlice = createAsyncThunk(
  "FacilityBankAnalysisSlice/getSearchStepSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await FacilityBankAnalysisSliceService.getSearchStepService(userInput);

      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error?.response?.status || "Error",
        description: error?.response?.statusText || "Unexpected error occurred",
        duration: 3,
      });
      return rejectWithValue(
        error?.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getGuarantorSLice = createAsyncThunk(
  "FacilityBankAnalysisSlice/getGuarantorSLice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await FacilityBankAnalysisSliceService.getGuarantorService(userInput);

      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error?.response?.status || "Error",
        description: error?.response?.statusText || "Unexpected error occurred",
        duration: 3,
      });
      return rejectWithValue(
        error?.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

  export const getColllateralSlice = createAsyncThunk(
    "FacilityBankAnalysisSlice/getColllateralSlice",
    async (userInput, { rejectWithValue }) => {
      try {
        const response =
          await FacilityBankAnalysisSliceService.getColllateralService(userInput);

        if (response.status === 200 && response.data) {
          return response.data;
        } else {
          return rejectWithValue({
            status: "Error",
            response: response?.data?.message || "Unexpected response!",
          });
        }
      } catch (error) {
        notification.error({
          message: error?.response?.status || "Error",
          description: error?.response?.statusText || "Unexpected error occurred",
          duration: 3,
        });
        return rejectWithValue(
          error?.response?.data?.message || "Unexpected response!"
        );
      }
    }
  );

  export const getDeviasiSlice = createAsyncThunk(
    "FacilityBankAnalysisSlice/getDeviasiSlice",
    async (userInput, { rejectWithValue }) => {
      try {
        const response = await FacilityBankAnalysisSliceService.getDeviasiService(
          userInput
        );

        if (response.status === 200 && response.data) {
          return response.data;
        } else {
          return rejectWithValue({
            status: "Error",
            response: response?.data?.message || "Unexpected response!",
          });
        }
      } catch (error) {
        notification.error({
          message: error?.response?.status || "Error",
          description: error?.response?.statusText || "Unexpected error occurred",
          duration: 3,
        });
        return rejectWithValue(
          error?.response?.data?.message || "Unexpected response!"
        );
      }
    }
  );

export const FacilityBankAnalysisSlice = createSlice({
  name: "facilityBankAnalysis",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    setCreditStepFacility: (state, action) => {
      state.creditStepFacility = action.payload;
    },
    setStatusResponReset: (state) => {
      state.statusRespon = 0;
      state.facilityItem = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Bank analis
      .addCase(getFacilityBankAnalysisSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getFacilityBankAnalysisSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.facilityBankAnalysisList = action.payload;
        state.getCount = action.payload.count || 0;
      })
      .addCase(getFacilityBankAnalysisSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //ADD
      .addCase(addFacilityBankAnalysisSlice.pending, (state) => {
        state.loadingBankAanalis = true;
      })
      .addCase(addFacilityBankAnalysisSlice.fulfilled, (state, action) => {
        console.log("actionpostGuarantor", action);
        state.loadingBankAanalis = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.noApkFAS = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
      })
      .addCase(addFacilityBankAnalysisSlice.rejected, (state, action) => {
        state.loadingBankAanalis = false;
        state.result = action.payload;
        state.showMessage = true;
        state.noApkFAS = "";
      })

      // ANALISA KEUANGAN
      //ADD
      .addCase(addFacilityFinAnalysisSlice.pending, (state) => {
        state.loadingFinAalysis = true;
      })
      .addCase(addFacilityFinAnalysisSlice.fulfilled, (state, action) => {
        console.log("actionpostGuarantor", action);
        state.loadingFinAalysis = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.noApkFAS = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
      })
      .addCase(addFacilityFinAnalysisSlice.rejected, (state, action) => {
        state.loadingFinAalysis = false;
        state.result = action.payload;
        state.showMessage = true;
        state.noApkFAS = "";
      })
      // ANALISA KEBUTUHAN MODAL KERJA
      //ADD
      .addCase(addFacilityCapitalAnalysisSlice.pending, (state) => {
        state.loadingFacilityCapital = true;
      })
      .addCase(addFacilityCapitalAnalysisSlice.fulfilled, (state, action) => {
        // console.log("actionpostGuarantor", action);
        state.loadingFacilityCapital = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.noApkFAS = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
      })
      .addCase(addFacilityCapitalAnalysisSlice.rejected, (state, action) => {
        state.loadingFacilityCapital = false;
        state.result = action.payload;
        state.showMessage = true;
        state.noApkFAS = "";
      })
      // GET CREDIT SCORING FAC ITEM
      .addCase(getCreditScoringFacItemSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCreditScoringFacItemSlice.fulfilled, (state, action) => {
        // console.log('getCreditScoringFacItemSlice',action); 
        state.loading = false;
        state.creditScoringFacItem = action.payload;
      })
      .addCase(getCreditScoringFacItemSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      // POS CREDIT SCORING FAC ITEM
      .addCase(posCreditScoringFacItemSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(posCreditScoringFacItemSlice.fulfilled, (state, action) => {
        console.log("actionpostGuarantor", action?.payload);

        state.loading = false;
        state.calculateCreditScoringFacList = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.noApkFAS = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
      })
      .addCase(posCreditScoringFacItemSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.noApkFAS = "";
      })
      // POS CREDIT SCORING FAC SAVE
      .addCase(posCreditScoringFacSaveSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(posCreditScoringFacSaveSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.noApkFAS = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
      })
      .addCase(posCreditScoringFacSaveSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.noApkFAS = "";
      })
      // GET CREDIT SCORING FAC ITEM
      .addCase(getSearchStepSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSearchStepSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.facilityItem = action.payload;
      })
      .addCase(getSearchStepSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //
      // GET GUARANTOR
      .addCase(getGuarantorSLice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getGuarantorSLice.fulfilled, (state, action) => {
        state.loading = false;
        state.guarantorItem = action.payload;
      })
      .addCase(getGuarantorSLice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      // GET COLLATERAL
      .addCase(getColllateralSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getColllateralSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.collateralItem = action.payload;
      })
      .addCase(getColllateralSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      // GET DEVIASI
      .addCase(getDeviasiSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDeviasiSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.deviasiItem = action.payload;
      })
      .addCase(getDeviasiSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
    //
  },
});

export const {
  showNotification,
  hideNotification,
  showLoading,
  setStatusResponReset,
  setCreditStepFacility,
} = FacilityBankAnalysisSlice.actions;

export default FacilityBankAnalysisSlice.reducer;
